.stars {
  display: inline-flex;
  gap: 2px;
  color: #f5a623;

  .starOff {
    color: var(--vc-border-strong);
  }

  .starBtn {
    display: inline-flex;
    padding: 2px;
    border-radius: 4px;
    transition: transform var(--vc-duration) var(--vc-ease);

    &:hover {
      transform: scale(1.12);
    }
  }
}
